<main
  class="faq-page-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <div class="header">
        <img class="image-banner" src="/assets/banners/faq_page.webp" />
      </div>
      <div class="sub-header">
        @if (lang !== 'AR') {
          <h1>Popsy Support</h1>
          <span>Get answers and support quickly and easily. </span>
        } @else {
          <h1>خدمة دعم العملاء</h1>
          <span>احصل على إجابات ودعم سريع وسهل. </span>
        }
        <span class="fixed-space-32" aria-hidden="true"></span>

        <div class="grid sub">
          <div class="grid-item popsy-card">
            @if (lang !== 'AR') {
              <h2>Where is my order?</h2>

              <span
                class="popsy-button-option"
                [routerLink]="trackUrlFragment()"
                [queryParams]="queryParams$ | async"
                >Track my order</span
              >
              <span class="fixed-space-12" aria-hidden="true"></span>
            } @else {
              <h2>أين أصبح طلبي؟</h2>
              <span
                class="popsy-button-option"
                [routerLink]="trackUrlFragment()"
                [queryParams]="queryParams$ | async"
                >تتبع الطلب
              </span>
              <span class="fixed-space-12" aria-hidden="true"></span>
            }
          </div>
          <div class="grid-item popsy-card">
            @if (lang !== 'AR') {
              <h2>I want to return an item</h2>
              <a class="popsy-button-option" href="https://popsy.app/refund-form"
                >How to return an item</a
              >
              <span class="fixed-space-12" aria-hidden="true"></span>
            } @else {
              <h2>أود إعادة منتج معيّن</h2>
              <a class="popsy-button-option" href="https://popsy.app/refund-form">
                كيف يمكنني إعادة المنتج
              </a>
              <span class="fixed-space-12" aria-hidden="true"></span>
            }
          </div>
        </div>
        <span class="fixed-space-32" aria-hidden="true"></span>
      </div>
      <article class="content-wrapper">
        <section class="full-width">
          @if (lang !== 'AR') {
            <h1>Articles</h1>
          } @else {
            <h1>المواضيع</h1>
          }
          <div class="grid">
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('payment-methods')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Payment Methods</h2>
              } @else {
                <h2>طرق الدفع</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('shipping-and-delivery')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Shipping And Delivery</h2>
              } @else {
                <h2>الشحن والتسليم</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('warranty-and-refunds')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Warranty and Refunds</h2>
              } @else {
                <h2>الضمانات والاسترداد</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>

            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('installment-plans')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Pay in Installments</h2>
              } @else {
                <h2>الدغع على أقساط</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('refurbished-faq')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Refurbished FAQ</h2>
              } @else {
                <h2>الأسئلة الأكثر شيوعاً حول الأجهزة المجددة</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('product-conditions')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Product Conditions</h2>
              } @else {
                <h2>شروط المنتج</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
            <a
              class="grid-item popsy-card"
              [routerLink]="getInfoFragment('extended-warranty')"
              [queryParams]="queryParams$ | async">
              @if (lang !== 'AR') {
                <h2>Extended Warranty</h2>
              } @else {
                <h2>كفالة بوبسي</h2>
              }
              <span class="read-more">{{ t('label_read_more') }}</span>
            </a>
          </div>

          <span class="fixed-space-64" aria-hidden="true"></span>

          <div class="faq">
            @if (lang !== 'AR') {
              <h1>Most frequently asked questions</h1>
            } @else {
              <h1>الأسئلة الأكثر شيوعاً</h1>
            }

            @for (item of frequentFAQData; track item; let i = $index) {
              @if (
                (lang !== 'AR' && item.question.length) ||
                (lang === 'AR' && item.questionAr.length)
              ) {
                <div class="item">
                  <div class="question" (click)="item.open = !item.open">
                    @if (lang !== 'AR') {
                      <span>{{ item.question }}</span>
                    }
                    @if (lang === 'AR') {
                      <span>{{ item.questionAr }}</span>
                    }
                    <span class="fixed-space-8" aria-hidden="true"></span>
                    <popsy-icon-chevron-down
                      class="icon icon fill-gray-01"
                      [class.selected]="item.open" />
                  </div>
                  @if (lang !== 'AR') {
                    <div
                      class="answer"
                      [class.selected]="item.open"
                      [innerHTML]="item.answer"></div>
                  }
                  @if (lang === 'AR') {
                    <div
                      class="answer"
                      [class.selected]="item.open"
                      [innerHTML]="item.answerAr"></div>
                  }
                  @if (i === 1 && item.open) {}
                  <span class="line fill-row"></span>
                </div>
              }
            }
          </div>
        </section>
      </article>
      <div class="sub-header negative">
        @if (lang !== 'AR') {
          <h1>Still have questions?</h1>
          <span class="fixed-space-16" aria-hidden="true"></span>
          <span class="popsy-button-option" (click)="openFeedbackForm()">Contact us</span>
        } @else {
          <h1>هل لا يزال لديك أية أسئلة؟</h1>
          <span class="fixed-space-16" aria-hidden="true"></span>
          <span class="popsy-button-option" (click)="openFeedbackForm()">
            تواصل معنا
          </span>
        }

        <span class="fixed-space-12" aria-hidden="true"></span>
        <span class="fixed-space-32" aria-hidden="true"></span>
      </div>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
